import React from "react";
import DateTimePicker from "./DatePickerWrapper";
import ErrorHandlingFormHelperText from "@civicplus/preamble-ui/lib/ErrorHandlingFormHelperText/ErrorHandlingFormHelperText";
import Range from "@civicplus/preamble-ui/lib/Range";
import DateTimeRange from "@civicplus/preamble-ui/lib/DateTimeRange/DateTimeRange";
import classNames from "classnames";

export const DateRangeWrapper = React.forwardRef<
  HTMLDivElement,
  React.ComponentProps<typeof DateTimeRange>
>((props, ref) => {
  const {
    disabled,
    error,
    errorMessage,
    format,
    fromProps,
    id,
    helperText,
    label,
    locale,
    maxValue,
    minValue,
    onBlur,
    required,
    toProps,
    value,
    pickerType,
    keyboard,
    executeValidation,
    className,
    fullWidth,
    onChange,
    ...otherProps
  } = props;

  const errorGlobal =
    typeof error === "string" ? error : error?.to || error?.from;
  const onlyErrorString = !error?.from && !error?.to && error;
  const onlyErrorMessageString =
    typeof errorMessage === "string" ? errorMessage : false;

  return (
    <div className="prmbl-dateTimeRange-wrapper" ref={ref}>
      <Range
        {...otherProps}
        disabled={disabled}
        component={DateTimePicker}
        executeValidation={executeValidation}
        errorMessage={errorMessage}
        fromProps={{
          ...fromProps,
          errorMessage: errorMessage?.from,
          error: error?.from,
          minValue: fromProps.minValue || minValue,
          maxValue: fromProps.maxValue || maxValue,
          pickerType: pickerType,
          keyboard: keyboard,
          fullWidth: fullWidth,
        }}
        error={errorGlobal}
        id={id}
        className={classNames("prmbl-dateTimeRange", className)}
        label={label}
        onChange={onChange}
        onBlur={onBlur}
        required={required}
        toProps={{
          ...toProps,
          errorMessage: errorMessage?.to,
          error: error?.to,
          minValue: toProps.minValue || minValue,
          maxValue: toProps.maxValue || maxValue,
          pickerType: pickerType,
          keyboard: keyboard,
          fullWidth: fullWidth,
        }}
        value={value}
      />
      <ErrorHandlingFormHelperText
        id={id ? `${id}-datetime-range-error-handling-helper-text` : undefined}
        helperText={helperText}
        error={onlyErrorString}
        errorMessage={onlyErrorMessageString}
      />
    </div>
  );
});

DateRangeWrapper.displayName = "DateRangeWrapper";

DateRangeWrapper.defaultProps = {
  toProps: {},
  fromProps: {},
};

export default DateRangeWrapper;
